import { Fragment } from 'react';
import { Dropdown, Menu } from 'antd';
import { CalendarRange } from 'lucide-react';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

import DropdownButton from '../DropdownButton';
import { DropdownMenuPanel } from '../DropdownPanel';

export interface AnalyticsPeriodOption<TValue extends string> {
    dividerBefore?: boolean;
    label: string;
    value: TValue;
}

export interface AnalyticsPeriodDropdownProps<TValue extends string> {
    onChange: (value: TValue) => void;
    options: AnalyticsPeriodOption<TValue>[];
    value: TValue;
}

const AnalyticsPeriodDropdown = <TValue extends string>({
    onChange,
    options,
    value,
}: AnalyticsPeriodDropdownProps<TValue>): JSX.Element => {
    const { token } = useAntDesignTheme();
    const selectedOption = options.find((option) => option.value === value);

    return (
        <Dropdown
            trigger={['click']}
            popupRender={() => (
                <DropdownMenuPanel selectedKeys={[value]} onClick={(event) => onChange(event.key as TValue)}>
                    {options.map((option) => (
                        <Fragment key={option.value}>
                            {option.dividerBefore ? <Menu.Divider /> : null}
                            <Menu.Item key={option.value}>{option.label}</Menu.Item>
                        </Fragment>
                    ))}
                </DropdownMenuPanel>
            )}
        >
            <DropdownButton size='small' type='dashed'>
                <CalendarRange size='0.825rem' style={{ color: token.colorTextTertiary }} />
                {selectedOption?.label ?? value}
            </DropdownButton>
        </Dropdown>
    );
};

export default AnalyticsPeriodDropdown;
